import React from 'react';
import LeftBar from '../Components/LeftBar';
import Dashnav from '../Components/Dashnav';
import DailyBriefingComp from './DailyBriefingComp';

function DailyBriefing() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <DailyBriefingComp />
      </div>
    </div>
  );
}

export default DailyBriefing;
